var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancelled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.65916 6.72177C4.46711 8.15224 3.75 9.99238 3.75 12C3.75 16.5563 7.44365 20.25 12 20.25C14.0076 20.25 15.8478 19.5329 17.2782 18.3408L5.65916 6.72177ZM5.05366 5.15815C3.31987 6.91826 2.25 9.33419 2.25 12C2.25 17.3848 6.61522 21.75 12 21.75C14.6738 21.75 17.0962 20.6737 18.8577 18.9307C18.8702 18.9198 18.8824 18.9083 18.8944 18.8963C18.9063 18.8845 18.9177 18.8723 18.9286 18.8598C20.6728 17.0982 21.75 14.6749 21.75 12C21.75 6.61522 17.3848 2.25 12 2.25C9.33311 2.25 6.91631 3.32073 5.15602 5.05576C5.13759 5.07097 5.11972 5.08719 5.10248 5.10444C5.08519 5.12173 5.06891 5.13966 5.05366 5.15815ZM6.71964 5.66094L18.3391 17.2804C19.5322 15.8496 20.25 14.0086 20.25 12C20.25 7.44365 16.5563 3.75 12 3.75C9.99138 3.75 8.15041 4.46782 6.71964 5.66094Z",
    fill: "#121010"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelled);
export default __webpack_public_path__ + "static/media/Cancelled.064d054a320bf9dcf5794387ddb64d5c.svg";
export { ForwardRef as ReactComponent };